import {
  UPDATE_TIME
} from "./constants";


export const updateTime = (payload: Date) => {
  return {
    type: UPDATE_TIME,
    payload
  };
};